import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page-container">
      {/* Breadcrumb Section */}
      <div className="policy-breadcrumb">
        <div className="breadcrumb-content">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb-list">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Privacy Policy
              </li>
            </ol>
          </nav>
          <h1 className="breadcrumb-title">Privacy Policy</h1>
        </div>
      </div>

      <div className="policy-wrapper">
        <div className="policy-content">
          {/* Header Section */}
          <header className="policy-header">
            <p className="policy-update-date"><strong>Updated effective from 1st April, 2022</strong></p>
            
            <div className="policy-notice-banner">
              <h2>Please read this privacy policy carefully before using the site</h2>
              <p>
                Your privacy matters! Protecting your private information is a priority for 
                Click4pay Payment Services Private Limited. This Privacy Policy explains how we 
                collect, process, use, share and protect information about you.
              </p>
            </div>
          </header>

          {/* Policy Sections */}
          <div className="policy-sections">
            <section id="scope" className="policy-section">
              <h2>Scope and application</h2>
              <p>
                This Privacy policy applies to everyone situated in any part of the world 
                that uses or accesses the Click4pay website and its Services.
              </p>
            </section>

            <section id="collection" className="policy-section">
              <h2>Collection of personal and other information</h2>
              <p>
                All information that the User provides to us directly shall be stored, such as 
                when the User creates or modifies the User's account, requests services, 
                contacts customer support, or otherwise communicates with us. The User takes 
                full responsibility for ensuring that the information provided or submitted is 
                accurate. Click4pay shall make no effort to validate any information provided by 
                the User for use in Services with respect to content, correctness or usability.
              </p>
              <p>
                We with an intention to provide the best service possible, we could ask the 
                User to share more information as and when needed. When the User uses our 
                Services, we collect information about the User in the following general 
                categories, including but not limited to:
              </p>
              <ul className="policy-list">
                <li>The Username, passwords, email address, name, address, age, date of birth, gender, nationality, site preferences, browsing history, etc., as well as any images or other information uploaded/published by the User on the Website.</li>
                <li>Certain information about the User based upon the User's IP address and the User's behavior on the Website, and the User expressly consents to the same.</li>
                <li>If the User chooses to purchase products or services from the Website, the User's buying behavior and trends.</li>
                <li>If the User chooses to post messages/reviews/feedback anywhere on the Website, including but not limited to product pages, message boards, chat rooms, other message areas, etc., all such information provided/uploaded will be collected and stored by the Company indefinitely.</li>
              </ul>
            </section>

            <section id="use" className="policy-section">
              <h2>Use of information</h2>
              <p>We may use the information we collect about from the User to:</p>
              <ul className="policy-list">
                <li>Provide, maintain, and improve our Services, including, for instance, to facilitate payments, send receipts, provide products and services the User requests, develop new features, provide customer support to Users, develop safety features, authenticate Users, and send product updates and administrative messages;</li>
                <li>Perform internal operations, including, for instance, to prevent fraud and misuse of our Services; to troubleshoot software bugs and operational problems; to conduct data analysis, testing, and research; and to monitor and analyze usage and activity trends;</li>
                <li>Send the User communications we believe shall be of interest to the User, including information about products, services, promotions, news, and events of Click4pay and other companies, where permissible and according to local applicable laws; and to process contest, sweepstake, or other promotion entries;</li>
                <li>Personalize and improve the Services, including providing or recommending features, content, social connections, referrals, promotions, surveys and advertisements.</li>
              </ul>
            </section>

            <section id="sharing" className="policy-section">
              <h2>Sharing of information</h2>
              <p>
                Click4pay reserves the right to share the information it collects from the User 
                as described in this Statement or as described at the time of collection or 
                sharing, including as follows:
              </p>
              <p>
                Click4pay only shares Personal Information with third parties in the limited 
                circumstances. We have the User's consent for the sharing of any sensitive 
                personal information to other trusted businesses or persons for the purpose 
                of processing User's information on our behalf. We require that these parties 
                agree to process such information based on our instructions and in compliance 
                with this Policy and any other appropriate confidentiality and security measures.
              </p>
              <p>
                We have a good faith belief that access, use, preservation or disclosure of 
                such information is reasonably necessary to: satisfy any applicable law, 
                regulation, legal process or enforceable governmental request including to 
                law enforcement and in response to a court order, detect, prevent, or otherwise 
                address fraud, technical or security issues, enforce applicable Terms of Use, 
                including investigation of potential violations thereof, or To protect ourselves 
                against third-party claims.
              </p>
            </section>

            <section id="security" className="policy-section">
              <h2>Information security</h2>
              <p>
                Click4pay takes precautions and this includes administrative, technical, and 
                physical measures – to safeguard the User's personal and sensitive information 
                against loss, misuse or theft, as well as against destruction, alteration, 
                disclosure and unauthorized access. However, no security system can be 
                completely secure. Therefore, despite our best efforts for safeguarding User's 
                Privacy we cannot guarantee the complete security of the User's Personal Information.
              </p>
              <p>
                Please exercise caution when determining what Personal Information the User 
                discloses via the Site. When the User uses our services or uploads/posts 
                information on the Site, some of the Personal Information the User shares is 
                visible to other Users and can be read, collected, or used by any other User. 
                The Users are responsible for such Personal Information the User chooses to 
                submit in such instances. For instance, if the User lists the User's name and 
                email address on any page on the Site, that information is public.
              </p>
              <p>
                Further, the Users are responsible for maintaining the confidentiality of the 
                User's account and password and for restricting access to the User's computer, 
                and the User agrees to accept responsibility for all activities that occur 
                under the User's account or password.
              </p>
            </section>

            <section className="policy-section">
              <h2>Analytics and third party advertisements/promotions</h2>
              <p>
                Click4pay may allow third party websites to provide audience measurement and 
                analytics services on our website. Click4pay may even allow third party websites 
                to serve advertisements on our behalf across the Internet, and to monitor, 
                track and report performance of those advertisements.
              </p>
              <p>
                Furthermore, the Website may contain links to other websites that may collect 
                personally identifiable information about the User. Click4pay will not be 
                responsible for the privacy practices or the content of any of the linked 
                websites, and the User expressly acknowledges the same and agrees that any 
                and all risks associated with data privacy will be borne entirely by the User.
              </p>
            </section>

            <section id="cookies" className="policy-section">
              <h2>Cookie</h2>
              <p>
                Our website uses "cookies" to help personalize the User's online experience. 
                A cookie is a text file that is placed on the User's device by a web server. 
                Cookies are uniquely assigned to the User and can only be read by a web server 
                in the domain that issued the cookie to the User.
              </p>
            </section>

            <section id="rights" className="policy-section">
              <h2>Account Information</h2>
              <p>
                The User may correct the User's account information at any time by logging 
                into the User's online account on the website. If the User wishes to cancel 
                the account, please email us: sales@Click4pay.com.
              </p>
              <p>
                Please note that in some cases we may retain certain information about the 
                User as required by law, or for legitimate business purposes to the extent 
                permitted by law. For instance, if the User has a standing credit or debt on 
                the User's account, or if we believe the User has committed fraud or violated 
                our Terms, we may seek to resolve the issue before deleting the User's information.
              </p>
            </section>

            <section className="policy-section">
              <h2>Promotional communications</h2>
              <p>
                The User may opt out of receiving promotional messages from Click4pay by following 
                the Unsubscribe instructions mentioned in those messages. If the User opts-out, 
                we may still send the User non-promotional/transactional communications, such 
                as those about the User account, Account balance, Status Updates about Services 
                the User has requested, or purchased.
              </p>
            </section>

            <section className="policy-section">
              <h2>Changes/modifications to the policy</h2>
              <p>
                Due to the rapidly evolving technologies on the World Wide Web and amendments 
                in the law pertaining to the Internet, we may update this privacy policy 
                occasionally. All revisions will be posted on our website itself. Hence, we 
                urge the User to review our Privacy Policy frequently. The User's continued 
                use of the Services after such notice shall mean the User's consent to the 
                changes. We encourage the User to periodically visit the website for the latest 
                information on our privacy practices.
              </p>
            </section>

            <section className="policy-section">
              <h2>Assignment</h2>
              <p>
                We may assign this contract at any time to any parent, subsidiary, or any 
                affiliated company, or as part of the sale to, merger with, or other transfer 
                of our company to another entity. We will post a notice on the website regarding 
                any change of ownership so that you have the opportunity to discontinue your 
                use of the website or cancel your registration if you do not wish to continue 
                to use the website and the Services under the new ownership.
              </p>
            </section>

            <section className="policy-section">
              <h2>Dispute resolution and jurisdiction</h2>
              <p>
                It is expressly agreed to by the User that the formation, interpretation and 
                performance of this Policy and any disputes arising here from will be resolved 
                through an Alternate Dispute Resolution ("ADR") mechanism. It is further agreed 
                to by the Parties that the contents of this Section shall survive even after 
                the termination or expiry of the Policy and/or Terms.
              </p>
              <p>
                In the event that the User is not satisfied with the resolution provided by 
                Click4pay and there exists a dispute, then the said dispute will be referred to 
                arbitration by a sole arbitrator to be appointed by Click4pay, and the award 
                passed by such sole arbitrator will be valid and binding on both Parties. The 
                Parties shall bear their own costs for the proceedings, although the sole 
                arbitrator may, in his/her sole discretion, direct either Party to bear the 
                entire cost of the proceedings. The arbitration shall be conducted in English, 
                and the seat of Arbitration shall be the city of Raipur in the state of 
                Chhattisgarh, India.
              </p>
              <p>
                The Parties expressly agree that the Terms of Use and Privacy Policy and any 
                other agreements entered into between the Parties are governed by the laws, 
                rules and regulations of India, and that the Courts at Raipur, Chhattisgarh 
                (India), shall have exclusive jurisdiction over any disputes arising between 
                the Parties.
              </p>
            </section>

            <section id="contact" className="policy-contact-section">
              <h2>Grievance officer</h2>
              <p>
                If the User finds any inconsistencies or has any grievances in relation to 
                the collection, storage, use, disclosure and transfer of the User's personal 
                information under this Policy or any terms of Click4pay Terms of Use, Privacy 
                Policy, etc. please contact the following: 
                <a href="mailto:sales@Click4pay.com" className="policy-contact-email">sales@Click4pay.com</a>.
              </p>
              <p>
                The Grievance Officer shall redress the grievances expeditiously within a 
                maximum period of one month, from the date of receipt of a grievance.
              </p>
            </section>

            <section className="policy-section">
              <h2>Miscellaneous</h2>
              <p>
                While Click4pay may retain any correspondence sent by the User, it does not 
                intend to collect or save any information from children below 18 years of age. 
                This website is also not intended for Users who are not competent to contract 
                under the provisions of Indian Contract Act, 1872.
              </p>
              <p>
                Further, any information sent to us by Internet e-mail or via the Website is 
                done at the User's risk and hence is not secure and is done so on a 
                non-confidential basis. If the User has any questions about this privacy 
                statement or needs any clarification on the same, the User can contact us at 
                <a href="mailto:sales@Click4pay.com" className="policy-contact-email">sales@Click4pay.com</a>
              </p>
            </section>

            <section className="policy-consent-section">
              <h2>User's consent</h2>
              <p>
                By using the Website and/or by providing information to Click4pay through the 
                website, the User consents to the collection and use of the information 
                disclosed by the User on the website in accordance with this Privacy Policy.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;